import SimpleQuestion from "./SimpleQuestion";
import Slider from "@material-ui/core/Slider";
import { useDispatch, useSelector } from "react-redux";
import * as theme from "../theme";
import { INSURER } from "../store/businesslogic/hardwiredlogic";
import { getFormState } from "../store/qf";
import { useEffect, useState } from "react";
const Percentage = ({
  text,
  node,
  handleAnswerChange,
  isNodeOpen,
  qfusermode,
}) => {
  const formstate = useSelector(getFormState);
  if (node.logic && node.logic.referencePercentParent) {
    try {
      var nodestate = formstate[node.formid].nodestate;
      Object.keys(nodestate).forEach(function (key, index) {
        if (
          key.includes(node.logic.referencePercentParent) &&
          nodestate[key]?.questionid == node.logic.referencePercentParent &&
          node.groupid == nodestate[key].groupid &&
          nodestate[key].answer &&
          node.answer &&
          formstate.currentnode.locationid === nodestate[key].locationid
        ) {
          const suffix = nodestate[key].type === "currency" ? "$" : "";
          let nf = new Intl.NumberFormat("en-US");
          var floatValue = (
            (node.answer / 100) *
            nodestate[key].answer
          ).toFixed(2);
          text = text + " (" + suffix + nf.format(floatValue) + " )";
        }
      });
    } catch (e) {}
  }
  return (
    <SimpleQuestion
      leftString={text}
      node={node}
      rightComponent={
        <PercentageSlider
          node={node}
          handleAnswerChange={handleAnswerChange}
          qfusermode={qfusermode}
        ></PercentageSlider>
      }
    ></SimpleQuestion>
  );
};

function valuetext(value) {
  return `${value} %`;
}

const PercentageSlider = ({ node, handleAnswerChange, qfusermode }) => {
  const [pctValue, setPctValue] = useState(node.answer || 0)
  const handleAnswer = (event, newValue) => {
    //handleAnswerChange(newValue);
    if(!isNaN(newValue)){
      setPctValue(newValue)
    }
  };

  const handleInputAnswer = (event) => {
    let input = event.target.value;
    if (!isNaN(input)) {
      let inputNumber = Number(input);

      if (inputNumber >= 0) {
        if (inputNumber > 100) inputNumber = 100;
        //handleAnswerChange(inputNumber);
        setPctValue(inputNumber)
      }
    }
  };
  const handleBlur = (event) => {
    handleAnswerChange(pctValue);
  }
  return (
    <div
      style={{
        display: "flex",
        height: "100%",
        alignItems: "center",
      }}
    >
      <div
        style={{
          display: "flex",
          height: "100%",
        }}
      >
        <input
          type="text"
          id={"stringInput" + node.id}
          style={{ ...theme.inputStyle, maxWidth: "6.5vw", textAlign: "center" }}
          value={pctValue}
          onChange={handleInputAnswer}
          onBlur={handleBlur}
          readOnly={qfusermode === INSURER ? true : false}
        ></input>
      </div>
      <div
        style={{
          marginRight: "1vw",
          fontFamily: "GibsonSemiBd",
          color: "lightgrey",
        }}
      >
        %{" "}
      </div>
      <div style={{ width: "65%" }}>
        <Slider
          getAriaValueText={valuetext}
          aria-labelledby="discrete-slider-always"
          step={1}
          //marks={marks}
          valueLabelDisplay="auto"
          value={pctValue}
          onChange={handleAnswer}
          onBlur={handleBlur}
          disabled={qfusermode === INSURER ? true : false}
        />
      </div>
    </div>
  );
};

export const PercentageSliderForMiniForm = ({
  node,
  handleAnswerChange,
  code,
  questionid,
  qfusermode,
}) => {
  // code = "ENGLISH";
  // questionid = "internal_1";
  // node = {
  //   answer: { internal: { ENGLISH: { internal_1: "hello this is answer" } } },
  // };
  const decideTheValue = (code, node, questionid) => {
    if (!node) return "";
    if (!node.answer) return "";
    if (!node.answer.internal) return "";
    if (!node.answer.internal[code]) return "";
    if (!node.answer.internal[code][questionid]) return "";

    return node.answer.internal[code][questionid];
  };

  const handleSliderAnswer = (event, newValue) => {
    handleAnswerChange(code, questionid, newValue);
  };

  const handleInputAnswer = (event) => {
    let input = event.target.value;
    if (!isNaN(input)) {
      let inputNumber = Number(input);

      if (inputNumber >= 0) {
        if (inputNumber > 100) inputNumber = 100;
        handleAnswerChange(code, questionid, inputNumber);
      }
    }
  };
  return (
    <div
      style={{
        display: "flex",
        height: "100%",
        alignItems: "center",
      }}
    >
      <div
        style={{
         
          display: "flex",
          height: "100%",
        }}
      >
        <input
          type="text"
          id={"stringInput" + node.id + "_" + code + "_" + questionid}
          style={{ ...theme.inputStyle, width: "3vw" }}
          value={decideTheValue(code, node, questionid)}
          onChange={handleInputAnswer}
          readOnly={qfusermode === INSURER ? true : false}
        ></input>
      </div>
      <div
        style={{
          marginRight: "1vw",
          fontFamily: "GibsonSemiBd",
          color: "lightgrey",
        }}
      >
        %{" "}
      </div>
      <div style={{ width: "65%" }}>
        <Slider
          getAriaValueText={valuetext}
          style={{ color: "white" }}
          aria-labelledby="discrete-slider-always"
          step={1}
          //marks={marks}
          valueLabelDisplay="off"
          value={decideTheValue(code, node, questionid)}
          onChange={handleSliderAnswer}
          disabled={qfusermode === INSURER ? true : false}
        />
      </div>
    </div>
  );
};

export default Percentage;
